<template>
  <img
    v-if="organisation.logo"
    :src="organisation.logo[size]"
    class="organisation-logo__image"
    :alt="organisation.name"
  />
  <div v-else :class="placeholderClassName">
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <text fill="currentColor" font-size="12" font-weight="500" text-anchor="middle">
        <tspan x="12" y="16.25">
          {{ organisation.name[0].toUpperCase() }}
        </tspan>
      </text>
    </svg>
  </div>
</template>

<script setup>
import { computed } from 'vue';

import joinClasses from '@/functions/join_classes';
import { stableHashForString } from '@/functions/stable_hash';

// Make sure this matches the number of variants defined in app/assets/stylesheets/05_components/organisation_logo.scss
const TOTAL_VARIANTS = 8
const BASE_CLASS = "organisation-logo__image-placeholder";

const props = defineProps({
  organisation: { type: Object, required: true },
  size: { type: Number, default: 72 },
});

const placeholderClassName = computed(() => {
  if (!props.organisation.id) return BASE_CLASS;

  let placeholderColor = `variant-${stableHashForString(props.organisation.id) % TOTAL_VARIANTS}`;
  return joinClasses(BASE_CLASS, [placeholderColor]);
});
</script>
